import React, { useState, useEffect, useCallback } from "react";
import { Row, Col, Space, Table } from "antd";
import { List, Button, Modal, Toast } from "antd-mobile";
import ajaxService from "../services/ajax-service";
import { useHistory } from "react-router-dom";
import { withLocalize } from "react-localize-redux";
import SearchModal from "./search-modal";
import Layout from "../layout";
import usePushNotifications from "../hooks/usePushNotifications";

const formatTime = (timeStr) => {
  if (!timeStr) return "";
  const [hourStr, minuteStr] = timeStr.split(":");
  let hour = parseInt(hourStr, 10);
  const minute = parseInt(minuteStr, 10);

  const ampm = hour >= 12 ? "PM" : "AM";
  hour = hour % 12 || 12;

  return `${hour}:${minute.toString().padStart(2, "0")} ${ampm}`;
};

const Home = ({ translate, activeLanguage }) => {
  const history = useHistory();
  const [city, setCity] = useState();
  const [zawal, setZawal] = useState();
  const [namaz, setNamaz] = useState([]);
  const [date, setDate] = useState();
  const [day, setDay] = useState("friday");
  const [dateHijri, setDateHijri] = useState();
  const [chasht, setChasht] = useState();
  const [ishraq, setIshraq] = useState();
  const [visible, setVisible] = useState();
  const [params, setParams] = useState({});
  const { subscribeToPush } = usePushNotifications();

  useEffect(() => {
    const getTodaysData = async () => {
      let response = await ajaxService.get("home");

      if (response != null) {
        let { city, namaz, zawal, date, dateHijri, chasht, ishraq, day } =
          response.data;

        setZawal(zawal);
        setChasht(chasht);
        setIshraq(ishraq);
        setNamaz(namaz);
        setDate(date);
        setDateHijri(dateHijri);
        setCity(city);
        setDay(day);
      }
    };

    getTodaysData();
  }, []);

  useEffect(() => {
    const searchMasajid = async () => {
      if (Object.keys(params).length > 0) {
        let response = await ajaxService.get("search", params);

        if (response.data.length) {
          history.push({
            pathname: "/masajid",
            state: { data: response.data },
          });
        } else {
          Toast.show({
            content: (
              <span style={{ whiteSpace: "nowrap" }}>
                No masajid found near you
              </span>
            ),
          });
        }
      }
    };
    searchMasajid();
  }, [params]);


  const handlesubscribe = async () => {
    const result = await subscribeToPush();
    if (result.success) {
      Toast.show({ content: "Subscription successful!" });
    } else {
      Toast.show({ content: result.message || "Subscription failed" });
    }
  };




  const renderNamaz = () => {
    if (!namaz) return null;

    if (activeLanguage.code === "en") {
      const dataSource = Object.keys(namaz).map((item, index) => ({
        key: index,
        namaz: translate(item),
        start: formatTime(namaz[item][0]),
        end: formatTime(namaz[item][1]),
      }));

      const columns = [
        {
          title: translate("namaz"),
          dataIndex: "namaz",
          key: "namaz",
          align: "center",
        },
        {
          title: translate("start"),
          dataIndex: "start",
          key: "start",
          align: "center",
        },
        {
          title: translate("end"),
          dataIndex: "end",
          key: "end",
          align: "center",
        },
      ];

      return (
        <List >
          <List.Item>
            <Table className="table-text" dataSource={dataSource} columns={columns} pagination={false} bordered />
          </List.Item>
        </List>
      );
    } else {
      const dataSource = Object.keys(namaz).map((item, index) => ({
        key: index,
        namaz: translate(item),
        start: namaz[item][0],
        end: namaz[item][1],
      }));

      const columns = [
        {
          title: translate("namaz"),
          dataIndex: "namaz",
          key: "namaz",
          align: "center",
        },
        {
          title: translate("start"),
          dataIndex: "start",
          key: "start",
          align: "center",
        },
        {
          title: translate("end"),
          dataIndex: "end",
          key: "end",
          align: "center",
        },
      ];

      return (
        <List>
          <List.Item>
            <Table className="table-text" dataSource={dataSource} columns={columns} pagination={false} bordered />
          </List.Item>
        </List>
      );
    }
  };


  const renderOther = () => {
    if (ishraq !== undefined) {
      const dataSource = [
        {
          key: "1",
          ishraq: formatTime(ishraq),
          chasht: formatTime(chasht),
          zawal: formatTime(zawal),
        },
      ];

      const columns = [
        {
          title: translate("ishraq"),
          dataIndex: "ishraq",
          key: "ishraq",
          align: "center",
        },
        {
          title: translate("chasht"),
          dataIndex: "chasht",
          key: "chasht",
          align: "center",
        },
        {
          title: translate("zawal"),
          dataIndex: "zawal",
          key: "zawal",
          align: "center",
        },
      ];

      return (
        <List.Item>
          <Table
            className="table-text"
            dataSource={dataSource}
            columns={columns}
            pagination={false}
            bordered
          />
        </List.Item>
      );
    }
  };


  return (
    <Layout title={dateHijri}>
      <div style={{ marginLeft: "10px", marginRight: "10px" }}>
        <List mode="card" style={{ marginTop: "20px" }}>
          <List.Item className="dashed-line">
            <Row style={{ textAlign: "center" }}>
              <Col span={8}><span className="city-text">{city}</span></Col>
              <Col span={8}><span className="day-text">{translate(day)}</span></Col>
              <Col span={8}><span className="date-text">{date}</span></Col>
            </Row>

          </List.Item>
          {renderOther()}
          {renderNamaz()}
          <List.Item >
            <Button
              block
              color="primary"
              size="medium"
              onClick={() => setVisible(true)}
            >
              {translate("near_me")}
            </Button>
          </List.Item>

          <List.Item>
            <Button block color="primary" size="medium" onClick={handlesubscribe}>
              {translate("subscribe_to_notifications")}

            </Button>
          </List.Item>
        </List>
      </div>

      <Modal
        visible={visible}
        title={translate("near_me")}
        showCloseButton
        onClose={() => {
          setVisible(false);
        }}
        content={<SearchModal setVisible={setVisible} setParams={setParams} />}
      />
    </Layout>
  );
};

export default withLocalize(Home);
